import React, { useState } from 'react';
import styles from './ThirdPartyInfo.css';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AddNewSignerPopup from './AddNewSignerPopUp';
import { countryInfo } from '../Constants/constants';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
AddNewProxy.propTypes = {
    getOnDemandSigners: PropTypes.func.isRequired,
    countryCode: PropTypes.string.isRequired,
    allThirdParties: PropTypes.array.isRequired,
    defaultTPs: PropTypes.array.isRequired,
    allRepresentators: PropTypes.array.isRequired
};
export default function AddNewProxy({ getOnDemandSigners, allRepresentators, countryCode, allThirdParties, defaultTPs }) {
    const [showPopup, setShowPopup] = useState(false);


    function addSigner() {
        setShowPopup(!showPopup);
    }

    const getAddedProxySigner = (odSigner) => {
        getOnDemandSigners(odSigner);
    }

    return (
        <div className={styles.addNewSignerMain}>
            <div className={styles.addNewSigner} onClick={() => addSigner()}>
                <div >
                    <AccountCircleIcon fontSize="large" />
                    <p>
                        <FormattedMessage id={'labels.ADD_PROXY'} />
                    </p>
                </div>
            </div>
            <AddNewSignerPopup allThirdParties={allThirdParties}
                               allRepresentators={allRepresentators}
                defaultTPs={defaultTPs}
                getOnDemandSigners={getAddedProxySigner}
                isProxy = {true}
                odContactNumber={`${countryInfo[countryCode].getIsdCode()} `}
                odEmail=""
                odName=""
                setShowPopup={setShowPopup}
                showPopup={showPopup}
            />
        </div>
    )

}
